export default "__VITE_ASSET__0Qa1bbH9__"